import React, { useState, useEffect } from 'react';
import { auth } from './firebaseConfig';
import { signInWithEmailAndPassword, getIdToken } from 'firebase/auth';
import { TextField, Button, Typography, Container, Paper, Stack } from '@mui/material';
import ForgotPasswordComponent from './ForgotPasswordComponent';
import { Navigate } from 'react-router-dom';

const AuthComponent = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [user, setUser] = useState(null);
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  useEffect(() => {
    const sessionToken = localStorage.getItem('sessionToken');
    const sessionExpiry = localStorage.getItem('sessionExpiry');

    if (sessionToken && sessionExpiry && Date.now() < sessionExpiry) {
      setUser({}); // Simulate user session
    } else {
      localStorage.removeItem('sessionToken');
      localStorage.removeItem('sessionExpiry');
    }
  }, []);

  const handleSignIn = async () => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const token = await getIdToken(userCredential.user);
      localStorage.setItem('sessionToken', token);
      localStorage.setItem('sessionExpiry', Date.now() + 12 * 60 * 60 * 1000); // 12 hours
      setUser(userCredential.user);
    } catch (error) {
      console.error('Error signing in:', error);
    }
  };


  return (
    <Container sx={{ mt: 8, py: 3 }}>
      <Typography variant="h4" gutterBottom align="center">Autenticación</Typography>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 2, maxWidth: 400, mx: 'auto' }}>
        {showForgotPassword ? (
          <ForgotPasswordComponent onBack={() => setShowForgotPassword(false)} />
        ) : user ? (
          <Navigate to="/" />
        ) : (
          <Stack spacing={2}>
            <TextField
              type="email"
              label="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
            />
            <TextField
              type="password"
              label="Contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
            />
            <Stack direction="row" spacing={2} justifyContent="center">
              <Button variant="contained" color="primary" onClick={handleSignIn}>
                Iniciar Sesión
              </Button>
            </Stack>
            <Button color="warning" onClick={() => setShowForgotPassword(true)} sx={{ mt: 2 }}>
              ¿Olvidaste tu contraseña?
            </Button>
          </Stack>
        )}
      </Paper>
    </Container>
  );
};

export default AuthComponent;
